import CalendarModuleCommand from '../store/schema/CalendarModuleCommands';
import { action } from 'satcheljs';

/**
 * Action invoked upon resettting module command on Calendar Module
 */
export let onResetModuleCommand = action('onResetModuleCommand');

/**
 * Action invoked upon requesting module command on Calendar Module
 */
export let onRequestModuleCommand = action(
    'onRequestModuleCommand',
    (moduleCommand: CalendarModuleCommand) => {
        return {
            moduleCommand,
        };
    }
);
